import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { NewTabHint } from '../ui/NewTabHint';
import { Reveal, stagger } from '../motion/Reveal';
import type { LocalChurch } from '../../data/churches';

/**
 * Responsive church grid. Each card is a single link, so it is clickable as a
 * whole and reachable by keyboard with one tab stop and a visible focus ring.
 * Logos render at their own proportions on a consistent neutral card; until an
 * official file is supplied the card shows a labeled asset slot instead.
 */
export function ChurchDirectory({
  churches
}: {
  churches: LocalChurch[];
}) {
  return <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-51" data-mp="s8a4wl3jvuuh">
      {churches.map((church, index) => <Reveal key={church.id} as="li" delay={stagger(index % 3)} className="h-full" data-id="element-52" data-mp="o7gki1pbgy6c" data-mpi={index}>
          <a href={church.website} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-6 transition-transform duration-200 hover:-translate-y-1" data-id="element-53" data-mp="2tylomcusfzv3">
            <span className="flex h-28 items-center justify-center overflow-hidden rounded-2xl bg-[#F4F7FB] px-5" data-id="element-54" data-mp="2afx67gfv3a8o">
              {church.logo ? <img src={church.logo} alt={`${church.name} logo`} loading="lazy" className={`max-h-20 w-auto max-w-full object-contain ${church.invertLogo ? 'invert' : ''}`} data-id="element-55" data-mp="2fe8g1r65pkqw" /> : <span className="text-center font-meta text-[12px] font-semibold uppercase tracking-[0.14em] text-brand-navy" data-id="element-56" data-mp="2t8snrc4s6lt5">
                  {church.name} logo
                </span>}
            </span>

            <span className="mt-5 font-display text-xl font-bold leading-snug text-brand-navy" data-id="element-57" data-mp="13sjjxu56a11h">
              {church.name}
            </span>

            <span className="mt-auto flex items-center gap-1.5 pt-4 font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 group-hover:no-underline" data-id="element-58" data-mp="18rmntb9f217v">
              Visit Website
              <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-59" data-mp="wqmr166svko5" />
              <NewTabHint data-id="element-60" data-mp="1ape18hijkm70" />
            </span>
          </a>
        </Reveal>)}
    </ul>;
}